<script setup lang="ts">
import { computed } from 'vue';

const props = withDefaults(defineProps<{ currentDate?: Date }>(), {
  currentDate: () => new Date(),
});

const currentYear = computed(() => props.currentDate.getFullYear());
</script>

<template>
  <div role="contentinfo" class="px-4 bg-neutral-100 md:px-12 text-tiny md:text-xs">
    <div class="flex items-center justify-between h-12 md:h-20">
      <div>&copy; Copyright 1999-{{ currentYear }} Nuts.com</div>
      <div>
        <RouterLink to="/terms-and-conditions" class="pr-8 color-inherit sm:pr-12">
          <strong>Terms of Use</strong>
        </RouterLink>
        <RouterLink to="/privacy" class="color-inherit">
          <strong>Privacy Policy</strong>
        </RouterLink>
      </div>
    </div>
  </div>
</template>
